import { render, staticRenderFns } from "./DialogSaleInvoice.vue?vue&type=template&id=25c146dd"
import script from "./DialogSaleInvoice.vue?vue&type=script&lang=js"
export * from "./DialogSaleInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports